import { weightProp, alignProp, trimProp } from "../../../helpers";
import type { PropDef } from "../../../helpers";

const sizes = ["h1", "h2", "h3", "h4", "h5", "h6", "xl"] as const;
const weights = weightProp.values;

const headingPropDefs = {
  size: { type: "enum", values: sizes, default: "h1", responsive: true },
  weight: { ...weightProp, default: "bold" },
  align: alignProp,
  trim: trimProp,
} satisfies {
  size: PropDef<(typeof sizes)[number]>;
  weight: PropDef<(typeof weights)[number]>;
  align: typeof alignProp;
  trim: typeof trimProp;
};

export { headingPropDefs };
